import { MathUtils } from '../../../../shared/utils/MathUtils.ts';
const HASH_UPDATE_DEBOUNCE_MS = 150;
export class UIScrollController {
    handleUrlHash() {
        const hash = window.location.hash;
        const section = UIScrollController.getSectionFromHash(hash);
        this.scrollToSection(section);
    }
    onSidebarClick(event) {
        event.preventDefault();
        if (event.target === null) return;
        if (!(event.target instanceof HTMLElement)) return;
        const linkElement = event.target.closest('a');
        if (linkElement === null) return;
        const section = UIScrollController.getSectionFromHash(linkElement.href);
        this.scrollToSection(section);
        if (section) UIScrollController.updateUrlHash(section.id);
    }
    static updateUrlHash(sectionId) {
        if (window.location.hash === '#' + sectionId) return;
        history.replaceState(null, '', '#' + sectionId);
    }
    static getSectionFromHash(hash) {
        const sectionId = hash.split('#')[1];
        return document.getElementById(sectionId);
    }
    onContentScroll() {
        if (this.contentDiv == undefined) return;
        const children = Array.from(this.contentDiv.children);
        const maxTopPosition = this.contentDiv.scrollHeight - this.viewportDiv.clientHeight;
        const elementsInView = children.filter((child)=>{
            if (!(child instanceof HTMLElement)) return false;
            const childStyles = getComputedStyle(child);
            if (childStyles.display === 'none') return false;
            if (childStyles.visibility === 'hidden') return false;
            const validLocationForElement = child.offsetTop / this.contentDiv.scrollHeight * maxTopPosition;
            return validLocationForElement < this.viewportDiv.scrollTop;
        });
        const target = elementsInView[elementsInView.length - 1];
        if (target === undefined) return;
        if (target.id === '') return;
        const linkElement = this.sidebarDiv.querySelector(`a[href="#${target.id}"]`);
        if (linkElement === null) return;
        this.setCurrentSectionLink(linkElement);
        this.debouncedUpdateUrlHash(target.id);
    }
    debouncedUpdateUrlHash(sectionId) {
        if (this.hashUpdateTimer) clearTimeout(this.hashUpdateTimer);
        this.hashUpdateTimer = setTimeout(()=>UIScrollController.updateUrlHash(sectionId), HASH_UPDATE_DEBOUNCE_MS);
    }
    setCurrentSectionLink(linkElement) {
        if (this.currentSectionLink === linkElement) return;
        if (this.currentSectionLink) this.currentSectionLink.classList.remove(this.currentSectionLinkClass);
        this.currentSectionLink = linkElement;
        this.currentSectionLink.classList.add(this.currentSectionLinkClass);
    }
    scrollToSection(section) {
        if (section == null) return;
        const maxTopPosition = this.contentDiv.scrollHeight - this.viewportDiv.clientHeight;
        const scrollYMin = section.offsetTop / this.contentDiv.scrollHeight * maxTopPosition;
        const scrollYMax = Math.floor(scrollYMin + section.scrollHeight / this.contentDiv.scrollHeight * maxTopPosition);
        const scrollY = MathUtils.clamp(section.offsetTop, scrollYMin, scrollYMax);
        this.viewportDiv.scroll(0, scrollY);
    }
    selectFirstLink() {
        if (this.sidebarDiv == undefined) return;
        const firstLink = this.sidebarDiv.querySelector('a');
        if (firstLink === null) return;
        this.setCurrentSectionLink(firstLink);
    }
    constructor(contentDiv, sidebarDiv, viewportDiv = contentDiv, currentSectionLinkClass = 'active'){
        this.currentSectionLink = null;
        this.hashUpdateTimer = null;
        this.contentDiv = contentDiv;
        this.sidebarDiv = sidebarDiv;
        this.viewportDiv = viewportDiv;
        this.currentSectionLinkClass = currentSectionLinkClass;
        this.handleUrlHash();
        this.onContentScroll();
        if (this.currentSectionLink !== null) return;
        this.selectFirstLink();
    }
}
